import { useContext, useEffect, useState } from "react";
import useTranslator from "../../../hooks/useTranslator";
import { Modal } from "react-bootstrap";
import SingleProperty from "./SingleProperty";
import { useNavigate, useParams } from "react-router-dom";
import LandLordContext from "../../../context/landlord/LandLordContext";
import LinkedPropertiesPopup from "../../../components/Property/LinkedPropertiesPopup";
import {
  formatPropertyAddress,
  haveValue,
  toast,
} from "../../../helper/common";
import FullAddressFormModal from "../../../components/Property/FullAddressFormModal";
import AuthContext from "../../../context/auth/AuthContext";

const PropertyRow = ({
  data,
  onPropertyAward,
  tanentData,
  loadData,
  openLinkedPopup,
  setSearchPropId,
}) => {
  const { _t, i18n } = useTranslator();
  const { workspaceId } = useParams();
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [linkedTenantsPopup, setLinkedTenantsPopup] = useState(false);
  const [selectBtn, setSelectBtn] = useState(_t("select") + "...");
  const [preselectedTanents, setPreselectedTanents] = useState([]);
  const [selectedTanents, setSelectedTanents] = useState([]);
  const [saveTanentLoading, setsaveTanentLoading] = useState(false);
  const [urlParamsCleaned, setUrlParamsCleaned] = useState(false);
  const navigate = useNavigate();
  const landLordContext = useContext(LandLordContext);
  const { saveTanentData, editProperty } = landLordContext;
  const { user } = useContext(AuthContext);
  const [searchText, setSearchText] = useState("");
  const [showIsEditModal, setShowIsEditModal] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng").toLowerCase() || "en-us"
  );

  useEffect(() => {
    setCurrentLang(localStorage.getItem("i18nextLng").toLowerCase() || "en-us");
  }, [localStorage.getItem("i18nextLng")]);

  const isRowDisabled =
    data?.is_awarded === true &&
    data?.awardedWorkspace?.toString() !==
      user?.current_workspace?._id?.toString() &&
    data?.landlord?._id?.toString() !== user?._id?.toString();

  const property = data;
  // console.log("i18n?.language", i18n?.language);
  const propertyAddress = formatPropertyAddress(data, currentLang);

  const defaultState = {
    street_type: "",
    street: "",
    street_number: "",
    postcode: "",
    staircase: "",
    floor: "",
    door: "",
    municipality: "",
    province: "",
    code_ine: "",
    code_via: "",
    cadastral_reference: "",
    area: "",
    property_reference: "",
    washrooms: "",
    bedrooms: "",
  };

  const [formData, setFormData] = useState(defaultState);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  useEffect(() => {
    if (property) {
      setFormData((prev) => ({
        ...prev,
        ...property,
        floor: property.floor_number ?? property.floor ?? "",
        door: property.flat_number ?? "",
        municipality: property.muncipality ?? "",
      }));
    }
  }, [property]);

  const handleEditProperty = async (e) => {
    e.preventDefault();
    if (!property?._id) {
      toast.error(_t("failedToEditProperty"));
    }
    setSubmitLoading(true);
    await editProperty(property?._id, formData);
    setShowDetailsModal(false);
    setSubmitLoading(false);
    setShowIsEditModal(false);
    await loadData();
  };

  useEffect(() => {
    if (openLinkedPopup) {
      setLinkedTenantsPopup(true);
      setSearchPropId(null);

      // Clean up URL parameters after popup opens (only once)
      if (!urlParamsCleaned) {
        const currentParams = new URLSearchParams(window.location.search);
        if (currentParams.has("propertyId") || currentParams.has("propName")) {
          currentParams.delete("propertyId");
          currentParams.delete("propName");
          currentParams.delete("sharedprofileid");

          const newQuery = currentParams.toString();
          const baseUrl = workspaceId ? `/${workspaceId}/home` : `/home`;
          const newUrl = newQuery ? `${baseUrl}?${newQuery}` : baseUrl;

          window.history.replaceState(null, "", newUrl);
          setUrlParamsCleaned(true);
        }
      }
    }
  }, [openLinkedPopup, urlParamsCleaned, workspaceId, setSearchPropId]);

  const handleNavigateProfile = (assignedProp) => {
    navigate(
      `/${workspaceId}/profile-property?sharedprofileid=${assignedProp?._id}&step=linked_props`
    );
  };

  useEffect(() => {
    // Update button text whenever selected tenants change
    if (selectedTanents.length > 0) {
      const selectedLabels = tanentData
        .filter((tenant) => selectedTanents.includes(tenant.value))
        .map((tenant) => (
          <span className="placeholder_string">{tenant.label}</span>
        ));

      setSelectBtn(
        selectedLabels.length ? selectedLabels : _t("select") + "..."
      );
    } else {
      setSelectBtn(_t("select") + "...");
    }
  }, [selectedTanents, tanentData]);

  const handlePropSelect = (e) => {
    const selectedValues = e.map((val) => val.value);
    setSelectedTanents(selectedValues);
  };

  const handleSaveChanges = async (e, selectedList = null) => {
    const tempSelected = haveValue(selectedList)
      ? selectedList
      : selectedTanents;
    const originalTenantIds = preselectedTanents.map((tenant) => tenant.value);

    const add_tanents = tempSelected.filter(
      (tenantId) => !originalTenantIds.includes(tenantId)
    );
    const rejected_tanents = originalTenantIds.filter(
      (tenantId) => !tempSelected.includes(tenantId)
    );

    const payload = {
      property_id: data?._id,
      add_tanents,
      rejected_tanents,
    };

    try {
      const response = await saveTanentData(payload);
      if (response?.data?.status === "success") {
        loadData();
      }
    } catch (error) {
      console.error("Error saving tenants:", error);
    }
  };

  return (
    <>
      <tr
        className={`hideOnMobile second-row ${
          isRowDisabled ? "disable-data-row" : ""
        }`}
      >
        <td>
          <div className="d-flex align-items-center custom-gap-2">
            <div class="earner-thumbnail-wrapper d-flex align-items-center justify-content-center">
              <img src="/images/home-icon-green.svg" />
            </div>
            {propertyAddress}
            {/* {" -> ( "}
            {data?.street} -{" "}
            {Number.isNaN(parseInt(data?.street_number, 10))
              ? "N/A"
              : String(parseInt(data?.street_number, 10))}{" "}
            - {data?.floor_number}{" "}
            {data?.flat_number ? `- ${data?.flat_number}` : ""}
            {" ) <-"} */}
          </div>
        </td>
        <td>{data?.muncipality || "-"}</td>
        <td>{data?.postcode || "-"}</td>
        <td>{data?.report_rent || "-"}</td>
        <td>
          <div className="d-flex align-items-center">
            <div
              id={`divBtnLinkedTenant-${data?._id}`}
              onClick={() => setLinkedTenantsPopup(true)}
              className={`d-flex align-items-center bg-[#DBF1CA] cursor-pointer bg_test removeGreenBg tenantList`}
            >
              <div className="d-flex align-items-center custom-gap-2">
                <p className="linked_p">
                  {/* #NOTE: if the property is awarded to an application then we show the defualt 1 count */}
                  {property?.is_awarded
                    ? property?.current_application
                      ? 1
                      : data?.current_tenant?.length
                    : data?.skor_protect_data?.application_id
                      ? 1
                      : data?.skor_protect_data?.selected_tenants?.length ||
                        data?.sharedProfilesCount ||
                        0}
                </p>
                <img className="" src="/images/arrow-right-green.svg" />
              </div>
            </div>
          </div>
        </td>
        <td>
          {data?.extra_data?.source_url ? (
            <a
              target="_blank"
              className="cursor-pointer underline"
              href={data?.extra_data?.source_url}
              rel="noreferrer"
            >
              {data?.source_id ?? "-"}
            </a>
          ) : (
            <div>-</div>
          )}
        </td>
        <td>{data?.extra_data?.contact_name ?? "-"}</td>
        <td>
          <div
            className="cursor-pointer text-center"
            onClick={() => setShowDetailsModal(true)}
          >
            {_t("viewDetails")}{" "}
            <img
              className="arrowRightPropertyTable"
              src="/images/arrow-right-green.svg"
            />
          </div>
        </td>
      </tr>
      <div
        className={`table-mobile-card hideOnDesktop ${
          isRowDisabled ? "disable-data-row" : ""
        }`}
      >
        {/* Tenant */}
        <div className="d-flex justify-content-between gap-3 align-items-center mb-3 cursor-pointer">
          <div className="d-flex justify-content-start gap-3 align-items-center">
            <div className="earner-thumbnail-wrapper d-flex items-center justify-center mr-3">
              <img src="/images/home-icon-green.svg" />
            </div>
            <div className="main-text">{propertyAddress}</div>
          </div>
          <img
            className="profile-row-arrow-btn"
            onClick={() => setShowDetailsModal(true)}
            src="/images/arrow-right-green.svg"
          />
        </div>

        <div className="table-mobile-card-comp">
          {" "}
          <div className="table-mobile-card-data cursor-pointer">
            <p className="text-gray-500">{_t("municipality")}</p>
            <span className="card-text">{data?.muncipality}</span>
          </div>
          <div className="table-mobile-card-data cursor-pointer">
            <p className="text-gray-500">{_t("postCode")}</p>
            <span className="card-text">{data?.postcode}</span>
          </div>
          <div className="table-mobile-card-data">
            <p className="text-gray-500">{_t("linkedTo")}</p>
            <div
              id={`divBtnLinkedTenant-${data?._id}`}
              onClick={() => setLinkedTenantsPopup(true)}
              className="d-flex align-items-center cursor-pointer"
            >
              <p className="card-text">{data?.sharedProfilesCount || 0}</p>
              <img src="/images/arrow-right-green.svg" className="px-2" />
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showDetailsModal}
        className="metermodal wrapper-modal"
        centered
        onHide={() => setShowDetailsModal(false)}
      >
        <Modal.Body>
          <SingleProperty
            key={data?._id}
            property={data}
            // isParentLL={true}
            onPropertyAward={onPropertyAward}
            tanentData={tanentData}
            loadData={loadData}
            hideModal={(e) => setShowDetailsModal(false)}
            setLinkedTenantsPopup={setLinkedTenantsPopup}
            setShowIsEditModal={setShowIsEditModal}
            formData={formData}
          />
        </Modal.Body>
      </Modal>

      {showIsEditModal && (
        <div className="right-contentbar mobile-month-payment-box mobile-property-cadastre popup-overlay fixed inset-0 d-flex align-items-center justify-content-center z-50 wrapper-modal">
          <FullAddressFormModal
            isLandlord={true}
            setIsAddManuallyModal={() => {
              setShowDetailsModal(true);
              setShowIsEditModal(false);
            }}
            formData={formData}
            handleInputChange={handleInputChange}
            handleSubmit={handleEditProperty}
            onClose={() => {
              setShowDetailsModal(true);
              setShowIsEditModal(false);
            }}
            setFormData={setFormData}
            isEdit={true}
            submitLoading={submitLoading}
          />
        </div>
      )}
      {linkedTenantsPopup && (
        <LinkedPropertiesPopup
          detailsShow={linkedTenantsPopup}
          setDetailsShow={setLinkedTenantsPopup}
          onPropertyAward={onPropertyAward}
          property={data}
          selectBtn={selectBtn}
          tanentData={tanentData}
          preselectedTanents={preselectedTanents}
          handlePropSelect={handlePropSelect}
          handleSaveChanges={handleSaveChanges}
          saveTanentLoading={saveTanentLoading}
          handleNavigateProfile={handleNavigateProfile}
          setSelectedTanents={setSelectedTanents}
          selectedTanents={selectedTanents}
          searchText={searchText}
          setSearchText={setSearchText}
          setPreselectedTanents={setPreselectedTanents}
          setsaveTanentLoading={setsaveTanentLoading}
          loadData={loadData}
          currentLang={currentLang}
          onEditProperty={() => {
            setLinkedTenantsPopup(false);
            setShowDetailsModal(false);
            setShowIsEditModal(true);
          }}
        />
      )}
    </>
  );
};

export default PropertyRow;
